module.exports = __webpack_public_path__ + "static/media/earnedInADay_5000_7500.10d1c660.png";